module.exports = __webpack_public_path__ + "assets/media/s12.9e5b5892.mp3";